/**
 *
 * HeaderTitleMobile
 *
 */

import HeaderTitleMobile from './HeaderTitleMobile.jsx';
import './HeaderTitleMobile.less';

export default HeaderTitleMobile; 
